import { useEffect } from "react";

/**
 * A link to a job, opened on one of its cards: `job=<id>&card=Texts`.
 *
 * Without a card a job opens on whichever card was last open, which is right
 * for moving between jobs and wrong for "show me this customer's texts" from
 * the Messages inbox (ADR 0227).
 */
export function jobLink(jobId: string, card?: string): string {
  return card
    ? `job=${jobId}&card=${encodeURIComponent(card)}`
    : `job=${jobId}`;
}

/** The job and the card a `job=` route asks for. */
export function readJobRoute(hash: string): {
  jobId: string;
  card: string | null;
} {
  const [jobId = "", ...rest] = hash.replace(/^job=/, "").split("&");
  const card = new URLSearchParams(rest.join("&")).get("card");
  return { jobId, card: card || null };
}

/**
 * A card named in the link is used once. It becomes the remembered card, as if
 * it had been clicked, and the address goes back to the plain `job=<id>`: a
 * refresh or Back then keeps whichever card the person chose afterwards.
 */
export function useCardFromLink(
  jobId: string,
  card: string | null,
  remember: (card: string) => void,
): void {
  useEffect(() => {
    if (!card) return;
    remember(card);
    window.history.replaceState(window.history.state, "", `#${jobLink(jobId)}`);
  }, [jobId, card, remember]);
}
